import dayjs from "dayjs";
import dateFormat, {
  getDate,
  getExpiryDate,
  getRemainigTime,
  getTimeStamp,
} from "../utils/dateFormat";
import apiService from "./apiService";
import authService from "./authService";
import userService from "./userService";

const UploadFile = async (file, fileName) => {
  const base64 = await getBase64(file.files[0])?.then((state) => {
    return state.split(",")[1];
  });

  const apiData = {
    mercid: userService.userData.mercid,
    filename: fileName,
    userid: userService.userData.userid,
    exceldata: base64,
    // purposeid:templateDetails?.pop_id,
    // smstemplateid: templateDetails?.sms_templateid,
    // emailtemplateid: templateDetails?.email_templateid,
    // whatsapptemplateid: templateDetails?.whatsapp_templateid,
  };

  const response = await apiService.fetchData(apiData, "excelupload");

  return response;
};

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const getFileList = async (filterData) => {
  const apiData = {
    mercid: userService.userData.mercid,
    userid: userService.userData.userid,
    fileid: "",
    eventtype: "LISTING",
    fromdt: filterData?.fromdate,
    todt: filterData?.todate,
    searchtext: filterData?.searchtext,
    currentPage: filterData?.pagecount,
    pageSize: 10,
  };

  const response = await apiService.fetchData(apiData, "manageuploadfiles");

  return response;
};

const getInvoiceList = async (filterData) => {
  const data = {
    mercid: userService.userData.mercid,
    userid: userService.userData.userid,
    eventtype: filterData?.actiontype,
    fromdt: filterData?.fromdate,
    todt: filterData?.todate,
    searchtext: filterData?.searchtext,
    currentPage:
      (filterData?.actiontype === "DOWNLOAD" && 1) || filterData?.pagecount,
    pageSize:
      (filterData?.actiontype === "DOWNLOAD" && filterData?.totalcount) || 10,
  };

  const response = await apiService.fetchData(data, "listinvoice");

  if (filterData?.actiontype === "DOWNLOAD") {
    if (response.data) {
      const fileName = "InvoiceReport_" + getTimeStamp();
      const filestatus = handleFileDownload(response.data.exceldata, fileName);

      if (filestatus) {
        return {
          data: {
            fileName: fileName,
          },
        };
      } else {
        return { error: false };
      }
    }
  }

  return response;
};

const createInvoice = async (invoiceData) => {
  let expiryperiod =
    getRemainigTime(invoiceData?.expiry_date) > 999
      ? 999
      : getRemainigTime(invoiceData?.expiry_date);
  const apiData = {
    merc_order_date: getTimeStamp(),
    txntype: "invoice",
    notificationtype: "",
    linktype: (invoiceData?.allow_edit && "EDITABLE") || "NOT",
    smstemplateid: invoiceData?.sms_templateid || "",
    emailtemplateid: invoiceData?.email_templateid || "",
    whatsapptemplateid: invoiceData?.whatsapp_templateid || "",
    defaultamount: invoiceData?.param1 || "",
    merc_id: userService.userData.mercid,
    amount: invoiceData?.param1 || "",
    return_url: process.env.REACT_APP_BASE_URL + "/paymentlounge/payment",
    product_type: "",
    product_id: invoiceData?.param2 || "",
    userid: userService.userData.userid||"",
    customer_id: invoiceData?.customer_id || "",
    customer_name: invoiceData?.customer_name || "",
    customer_email: invoiceData?.email_id || "",
    customer_phone: invoiceData?.mobile_no || "",
    udf1: "",
    udf2: invoiceData?.order_desc || "",
    invoice_no: getTimeStamp(),
    order_desc: invoiceData?.order_desc || "",
    account_no: "",
    account_ifsc: "",
    allowed_split_payment: (invoiceData?.allow_edit && "1") || "0",
    due_date: getExpiryDate(invoiceData?.due_date, expiryperiod, "YYYY-MM-DD"),
    expiry_period: expiryperiod,
    param1: invoiceData?.param1 || "",
    param2: invoiceData?.param2 || "",
    param3: invoiceData?.param3 || "",
    param4: invoiceData?.param4 || "",
    param5: invoiceData?.param5 || "",
    param6: invoiceData?.param6 || "",
    param7: invoiceData?.param7 || "",
    param8: invoiceData?.param8 || "",
    param9: invoiceData?.param9 || "",
    param10: invoiceData?.param10 || "",

    additionalparam1: invoiceData?.additionalParam1 || "",
    additionalparam2: invoiceData?.additionalParam2 || "",
    additionalparam3: invoiceData?.additionalParam3 || "",
    additionalparam4: invoiceData?.additionalParam4 || "",
    additionalparam5: invoiceData?.additionalParam5 || "",
    addtionalChargeparam1: invoiceData?.param4 || "",
    addtionalChargeparam2: invoiceData?.param5 || "",
    addtionalChargeparam3: invoiceData?.additionalChargeParam3 || "",
    addtionalChargeparam4: invoiceData?.additionalChargeParam4 || "",
    addtionalChargeparam5: invoiceData?.additionalChargeParam5 || "",
    ispaymentLink: "Y",
    smscomm: (invoiceData?.sms_comm && "Y") || "N",
    emailcomm: (invoiceData?.email_comm && "Y") || "N",
    whatsappcomm: (invoiceData?.whatsapp_comm && "Y") || "N",
  };
  
  const response = await apiService.fetchData(apiData, "getinvoice");

  return response;
};

const getInvoiceDetails = async () => {
  const code =
    new URLSearchParams(window?.location?.search)?.get("data") || null;
  if (!code) {
    return { error: "no_code" };
  }

  const decData = authService.dec(code?.toString().replaceAll(" ", "+"));

  if (decData?.error) {
    return decData;
  }
  const invoiceData = JSON.parse(decData);

  const apiData = {
    merc_id: "",
    invoice_no: invoiceData.invoice_no,
    event_type: "click",
  };

  const response = await apiService.fetchData(apiData, "getinvoiceinfo");
  return response;
};

const createOrder = async (amount, invoiceData) => {
  const apiData = {
    merc_id: invoiceData?.merc_id,
    invoice_no: invoiceData?.invoice_no,
    amount: amount,
  };

  const response = await apiService.fetchData(apiData, "getorder");
  return response;
};

const getOverview = async () => {
  const apiData = {
    merc_id: userService.userData.mercid,
    role: userService.userData.role,
    user_id: userService.userData.userid,
    report_user: null,
    eventtype: "ALL",
  };

  const response = await apiService.fetchData(apiData, "getDashboardinfo");
  return response;
};

const bulkFileDownload = async (data) => {
  const apiData = {
    merc_id: userService.userData.mercid,
    file_id: data.pk_id,
    user_id: userService.userData.userid,
  };

  const fileName = data.filename?.replaceAll(" ", "_") + "_report";

  const response = await apiService.fetchData(apiData, "uploadfilestatus");

  if (response.data) {
    const filestatus = handleFileDownload(response.data.exceldata, fileName);

    if (filestatus) {
      return {
        data: {
          fileName: fileName,
        },
      };
    } else {
      return { error: false };
    }
  }

  return response;
};

const handleFileDownload = (file, fileName) => {
  try {
    const downloadLink = document.createElement("a");
    const linkSource = `data:application/Xlsx;base64,${file}`;
    downloadLink.href = linkSource;
    downloadLink.download = `${fileName}.xlsx`;
    downloadLink.target = "_blank";
    downloadLink.click();
    return true;
  } catch (error) {
    return false;
  }
};

const campaignService = {
  getInvoiceList: getInvoiceList,
  getFileList: getFileList,
  uploadFile: (file, fileName) => UploadFile(file, fileName),
  createInvoice: (invoiceData) => createInvoice(invoiceData),
  getInvoiceDetails: () => getInvoiceDetails(),
  createOrder: createOrder,
  getOverview: () => getOverview(),
  bulkFileDownload: bulkFileDownload,
  downloadExcelFile: handleFileDownload,
};

export default campaignService;
